export default __webpack_public_path__ + "static/BnjRev-b574d496e50b96aa70860f5eaaadfeaf.jpg";